export default "__VITE_ASSET__D7HrRX9___"